<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('qualitycheck.product.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.location"
          :label="$t('qualitycheck.product.location')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="customerSelectItems"
          v-model="item.customer"
          :items="customerSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.customer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="statusSelectItems"
          v-model="item.status"
          :items="statusSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.statu')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="machineSelectItems"
          v-model="item.machine"
          :items="machineSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="toolheadSelectItems"
          v-model="item.toolhead"
          :items="toolheadSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.toolhead')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialSupplySelectItems"
          v-model="item.materialSupply"
          :items="materialSupplySelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.materialsupply')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="industrialComputerSelectItems"
          v-model="item.industrialComputer"
          :items="industrialComputerSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.industrialcomputer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="controlUnitSelectItems"
          v-model="item.controlUnit"
          :items="controlUnitSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.controlunit')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="accessorySelectItems"
          v-model="item.accessory"
          :items="accessorySelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.accessory')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="softwareVersionSelectItems"
          v-model="item.softwareVersion"
          :items="softwareVersionSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.product.softwareversion')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="operatingSystemSelectItems"
          v-model="item.operatingSystem"
          :items="operatingSystemSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.product.operatingsystem')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="optionSelectItems"
          v-model="item.option"
          :items="optionSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.option')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-model="item._exists"
          :items="types"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('qualitycheck.product.type')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="userSelectItems"
          v-model="item.userAssembly"
          :items="userSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.userassembly')"
          item-text="login"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <h3>{{ $t('qualitycheck.product.startassembly') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.startAssembly_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.startAssembly_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
    <v-row>
      <h3>{{ $t('qualitycheck.product.endassembly') }}</h3>
    </v-row>
    <v-row>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.endAssembly_after"
          :label="$t('global.datestart')"
        />
      </v-col>

      <v-col cols="12" sm="6" md="6">
        <InputDate
          v-model="item.endAssembly_before"
          :label="$t('global.dateend')"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import InputDate from '../InputDate';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ProductFilter',
  components: {
    InputDate,
  },
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      types: [
        'accessory',
        'controlUnit',
        'industrialComputer',
        'operatingSystem',
        'machine',
        'materialSupply',
        'option',
        'toolhead',
      ],
    };
  },
  mounted() {
      this.customerGetSelectItems();
      this.productstatusGetSelectItems();
      this.machineGetSelectItems();
      this.toolheadGetSelectItems();
      this.materialSupplyGetSelectItems();
      this.industrialComputerGetSelectItems();
      this.operatingSystemGetSelectItems();
      this.controlUnitGetSelectItems();
      this.accessoryGetSelectItems();
      this.optionGetSelectItems();
      this.softwareVersionGetSelectItems();
      this.userGetSelectItems();
  },

  computed: {
    ...mapFields('customer', {
      customerSelectItems: 'selectItems',
    }),
    ...mapFields('user', {
      userSelectItems: 'selectItems',
    }),
    ...mapFields('productstatus', {
      statusSelectItems: 'selectItems',
    }),
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems',
    }),
    ...mapFields('materialsupply', {
      materialSupplySelectItems: 'selectItems',
    }),
    ...mapFields('industrialcomputer', {
      industrialComputerSelectItems: 'selectItems',
    }),
    ...mapFields('operatingsystem', {
      operatingSystemSelectItems: 'selectItems',
    }),
    ...mapFields('controlunit', {
      controlUnitSelectItems: 'selectItems',
    }),
    ...mapFields('accessory', {
      accessorySelectItems: 'selectItems',
    }),
    ...mapFields('option', {
      optionSelectItems: 'selectItems',
    }),
    ...mapFields('softwareversion', {
      softwareVersionSelectItems: 'selectItems',
    }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    }
  },
  methods: {
    ...mapActions({
      customerGetSelectItems: 'customer/fetchSelectItems',
      productstatusGetSelectItems: 'productstatus/fetchSelectItems',
      machineGetSelectItems: 'machine/fetchSelectItems',
      toolheadGetSelectItems: 'toolhead/fetchSelectItems',
      materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems',
      industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems',
      operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems',
      controlUnitGetSelectItems: 'controlunit/fetchSelectItems',
      accessoryGetSelectItems: 'accessory/fetchSelectItems',
      optionGetSelectItems: 'option/fetchSelectItems',
      softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems',
      userGetSelectItems: 'user/fetchSelectItems'
    }),
  }
};
</script>
